<div *transloco="let t; prefix: 'property-listing.features'" [formGroup]="featuresFormGroup" class="flex-1">
  <div class="flex flex-col rfs:gap-[72px]">
    <div class="flex flex-col gap-6">
      <h2 class="h2 text-black">{{ 'property-listing.tabs.roomsAndFeatures' | transloco }}</h2>
    </div>

    <div class="flex flex-col gap-6">
      <h3 class="h3 text-black">{{ t('subheaders.rooms') }}</h3>
      <div class="flex flex-row gap-6 justify-between">
        <div class="flex-1">
          <div class="font-semibold flex items-center gap-2 text-gray-950 group-disabled:text-gray-300 mb-6">
            <i class="icon-bed text-secondary-900"></i>
            {{ t('labels.bedrooms') }}
          </div>
          <div class="flex flex-col md:flex-row gap-4">
            <label class="visual-checkbox flex flex-col flex-1 max-w-14 h-14" for="oneBedroom">
              <input (click)="featuresFormGroup.controls.numberOfRooms.setValue(1)"
                [checked]="featuresFormGroup.controls.numberOfRooms.value === 1" class="opacity-0 absolute h-0 w-0"
                id="oneBedroom" type="checkbox">
              <span class="">1</span>
            </label>

            <label class="visual-checkbox flex flex-col flex-1 max-w-14 h-14" for="twoBedrooms">
              <input (click)="featuresFormGroup.controls.numberOfRooms.setValue(2)"
                [checked]="featuresFormGroup.controls.numberOfRooms.value === 2" class="opacity-0 absolute h-0 w-0"
                id="twoBedrooms" type="checkbox">
              <span class="">2</span>
            </label>

            <label class="visual-checkbox flex flex-col flex-1 max-w-14 h-14" for="threeBedrooms">
              <input (click)="featuresFormGroup.controls.numberOfRooms.setValue(3)"
                [checked]="featuresFormGroup.controls.numberOfRooms.value === 3" class="opacity-0 absolute h-0 w-0"
                id="threeBedrooms" type="checkbox">
              <span class="">3</span>
            </label>

            <label class="visual-checkbox flex flex-col flex-1 max-w-14 h-14" for="fourBedrooms">
              <input (click)="featuresFormGroup.controls.numberOfRooms.setValue(4)"
                [checked]="featuresFormGroup.controls.numberOfRooms.value === 4" class="opacity-0 absolute h-0 w-0"
                id="fourBedrooms" type="checkbox">
              <span class="">4</span>
            </label>

            <label class="visual-checkbox flex flex-col flex-1 max-w-14 h-14" for="fivePlusBedrooms">
              <input (click)="featuresFormGroup.controls.numberOfRooms.setValue(5)"
                [checked]="featuresFormGroup.controls.numberOfRooms.value >= 5" class="opacity-0 absolute h-0 w-0"
                id="fivePlusBedrooms" type="checkbox">
              <span class="">5+</span>
            </label>
          </div>
        </div>
        <div class="flex-1">
          <div class="font-semibold flex items-center gap-2 text-gray-950 group-disabled:text-gray-300 mb-6">
            <i class="icon-bathroom text-primary-900"></i>
            {{ t('labels.bathrooms') }}
          </div>
          <div class="flex flex-col md:flex-row gap-4">

            <label class="visual-checkbox flex flex-col flex-1 max-w-14 h-14" for="oneBathroom">
              <input (click)="featuresFormGroup.controls.numberOfBathrooms.setValue(1)"
                [checked]="featuresFormGroup.controls.numberOfBathrooms.value === 1" class="opacity-0 absolute h-0 w-0"
                id="oneBathroom" type="checkbox">
              <span class="">1</span>
            </label>


            <label class="visual-checkbox flex flex-col flex-1 max-w-14 h-14" for="twoBathrooms">
              <input (click)="featuresFormGroup.controls.numberOfBathrooms.setValue(2)"
                [checked]="featuresFormGroup.controls.numberOfBathrooms.value === 2" class="opacity-0 absolute h-0 w-0"
                id="twoBathrooms" type="checkbox">
              <span class="">2</span>
            </label>


            <label class="visual-checkbox flex flex-col flex-1 max-w-14 h-14" for="threeBathrooms">
              <input (click)="featuresFormGroup.controls.numberOfBathrooms.setValue(3)"
                [checked]="featuresFormGroup.controls.numberOfBathrooms.value === 3" class="opacity-0 absolute h-0 w-0"
                id="threeBathrooms" type="checkbox">
              <span class="">3</span>
            </label>


            <label class="visual-checkbox flex flex-col flex-1 max-w-14 h-14" for="fourBathrooms">
              <input (click)="featuresFormGroup.controls.numberOfBathrooms.setValue(4)"
                [checked]="featuresFormGroup.controls.numberOfBathrooms.value === 4" class="opacity-0 absolute h-0 w-0"
                id="fourBathrooms" type="checkbox">
              <span class="">4</span>
            </label>


            <label class="visual-checkbox flex flex-col flex-1 max-w-14 h-14" for="fivePlusBathrooms">
              <input (click)="featuresFormGroup.controls.numberOfBathrooms.setValue(5)"
                [checked]="featuresFormGroup.controls.numberOfBathrooms.value >= 5" class="opacity-0 absolute h-0 w-0"
                id="fivePlusBathrooms" type="checkbox">
              <span class="">5+</span>
            </label>

          </div>
        </div>
      </div>


      <!--      <div class="font-semibold flex items-center gap-2 text-gray-950 group-disabled:text-gray-300">-->
      <!--        WCs-->
      <!--        <i class="icon-info-circle text-gray-700 text-xl"></i>-->
      <!--      </div>-->
      <!--      <div class="flex flex-col md:flex-row gap-4">-->

      <!--        <label class="visual-checkbox flex flex-col flex-1" for="oneWC">-->
      <!--          <input (click)="featuresFormGroup.controls.numberOfWC.setValue(1)"-->
      <!--                 [checked]="featuresFormGroup.controls.numberOfWC.value === 1" class="opacity-0 absolute h-0 w-0"-->
      <!--                 id="oneWC"-->
      <!--                 type="checkbox">-->
      <!--          <i class="icon-toilet text-[40px]"></i>-->
      <!--          <span class="">1</span>-->
      <!--        </label>-->


      <!--        <label class="visual-checkbox flex flex-col flex-1" for="twoWCs">-->
      <!--          <input (click)="featuresFormGroup.controls.numberOfWC.setValue(2)"-->
      <!--                 [checked]="featuresFormGroup.controls.numberOfWC.value === 2" class="opacity-0 absolute h-0 w-0"-->
      <!--                 id="twoWCs"-->
      <!--                 type="checkbox">-->
      <!--          <i class="icon-toilet text-[40px]"></i>-->
      <!--          <span class="">2</span>-->
      <!--        </label>-->


      <!--        <label class="visual-checkbox flex flex-col flex-1" for="threeWCs">-->
      <!--          <input (click)="featuresFormGroup.controls.numberOfWC.setValue(3)"-->
      <!--                 [checked]="featuresFormGroup.controls.numberOfWC.value === 3" class="opacity-0 absolute h-0 w-0"-->
      <!--                 id="threeWCs"-->
      <!--                 type="checkbox">-->
      <!--          <i class="icon-toilet text-[40px]"></i>-->
      <!--          <span class="">3</span>-->
      <!--        </label>-->


      <!--        <label class="visual-checkbox flex flex-col flex-1" for="fourWCs">-->
      <!--          <input (click)="featuresFormGroup.controls.numberOfWC.setValue(4)"-->
      <!--                 [checked]="featuresFormGroup.controls.numberOfWC.value === 4" class="opacity-0 absolute h-0 w-0"-->
      <!--                 id="fourWCs"-->
      <!--                 type="checkbox">-->
      <!--          <i class="icon-toilet text-[40px]"></i>-->
      <!--          <span class="">4</span>-->
      <!--        </label>-->


      <!--        <label class="visual-checkbox flex flex-col flex-1" for="fivePlusWCs">-->
      <!--          <input (click)="featuresFormGroup.controls.numberOfWC.setValue(5)"-->
      <!--                 [checked]="featuresFormGroup.controls.numberOfWC.value >= 5" class="opacity-0 absolute h-0 w-0"-->
      <!--                 id="fivePlusWCs"-->
      <!--                 type="checkbox">-->
      <!--          <i class="icon-toilet text-[40px]"></i>-->
      <!--          <span class="">5+</span>-->
      <!--        </label>-->

      <!--      </div>-->
    </div>

    <div class="flex flex-col gap-6">
      <h3 class="h3 text-black">{{ t('subheaders.storage') }}</h3>

      <div class="flex lg:flex-row flex-col gap-4">
        <div class="flex flex-row items-center gap-4 w-full">
          <div class="flex-1 border border-gray-300 rounded-lg p-4">
            <label class="checkbox-selector" for="checkbox-selector-storage-inside">
              <input (click)="onStorageTypeClick(storageType.Internal)"
                [checked]="(featuresFormGroup.controls.storageType.value ?? []).indexOf(storageType.Internal) > -1"
                class="hidden" id="checkbox-selector-storage-inside" name="checkbox-selector-storage-inside"
                type="checkbox">
              <div class="checkbox-selector-content flex flex-row items-center justify-start ml-4">
                <span
                  class="checkbox-selector-text text-black font-semibold w-full">{{t('labels.storageTypeInternal')}}</span>
              </div>
            </label>
          </div>
          <div class="flex-1 border border-gray-300 rounded-lg p-4">
            <label class="checkbox-selector" for="checkbox-selector-storage-outside">
              <input (click)="onStorageTypeClick(storageType.External)"
                [checked]="(featuresFormGroup.controls.storageType.value ?? []).indexOf(storageType.External) > -1"
                class="hidden" id="checkbox-selector-storage-outside" name="checkbox-selector-storage-outside"
                type="checkbox">
              <div class="checkbox-selector-content flex flex-row items-center justify-start ml-4">
                <span class="checkbox-selector-text text-black font-semibold w-full">{{t('labels.storageTypeExternal') |
                  transloco}}</span>
              </div>
            </label>
          </div>
        </div>
      </div>

      <form id="property-wizard">
        <fieldset class="flex flex-col gap-3 group/input">
          <label class="font-semibold flex gap-2 items-center text-gray-950 group-disabled:text-gray-300">{{
            t('labels.storageArea') }}
            <i class="icon-info-circle text-xl text-gray-900"></i></label>
          <div class="flex flex-col lg:flex-row gap-4 items-center justify-center">
            <div class="min-w-[300px] flex-1">
              <ngx-slider (userChange)="onStorageSizeSliderChange($event)" [(value)]="storageArea"
                [options]="storageAreaSliderOptions"></ngx-slider>
            </div>
            <div
              class="flex-1 justify-between flex max-w-[150px] bg-white text-gray-500 rounded-full border border-gray-300 py-3 px-4 group-focus-within/input:border-[1.5px] group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none">
              <input formControlName="storageArea" max="800" min="20"
                onchange="if(this.value < 20) { this.value = 20; } else if (this.value > 800) { this.value = 800; }"
                placeholder="400" type="number">
              <span class="text-gray-900 font-semibold">m²</span>
            </div>
          </div>
        </fieldset>
      </form>
    </div>

    <div class="flex flex-col gap-6">
      <div class="flex flex-col">
          <h3 class="h3 mb-2 text-black">{{ t('subheaders.floor') }}</h3>
          <span class="text-gray-900 text-sm">{{ t('floor.details') }}</span>
      </div>
      <div class="flex md:flex-row flex-col items-center gap-6">
        <span class="text-gray-900 font-semibold text-lg">{{ t('floor.property') }}</span>
        <div class="counter-wrapper">
          <button (click)="floorValue(-1)" id="decrement">
            <i class="icon-minus"></i>
          </button>
          <input [value]="featuresFormGroup.controls.floor.value ?? 0" id="input" readonly="readonly" type="number">
          <button (click)="floorValue(1)" id="increment">
            <i class="icon-plus"></i>
          </button>
        </div>
        <app-apartment-options 
          *ngIf="this.showApartmentFloortype"
          [floor]="featuresFormGroup.controls.floor.value"
          [floorType]="featuresFormGroup.controls.floorType.value"
          [FillterApartmentsOptions]="this.filterButtons"
          class="w-full"
          (SelectedItem)="apartmentFloorTypeSelected($event)"
      ></app-apartment-options>
      </div>
    </div>

    <div class="flex flex-col gap-6">
      <h3 class="h3 text-black">{{ t('subheaders.accessibility') }}</h3>

      <label class="inline-flex border border-gray-300 p-4 items-start justify-between cursor-pointer rounded-lg"
        for="checkbox-accessibilityForDisabled">
        <input
          (click)="featuresFormGroup.controls.amenities.controls.accessibilityForDisabled.setValue(!featuresFormGroup.controls.amenities.controls.accessibilityForDisabled.value)"
          [checked]="featuresFormGroup.controls.amenities.controls.accessibilityForDisabled.value === true"
          class="sr-only peer toggle-input" id="checkbox-accessibilityForDisabled" type="checkbox">
        <div class="flex flex-col">
          <span class="font-semibold text-black">{{ t('labels.accessibilityForDisabled') }}</span>
          <span class="text-sm text-gray-800">{{ t('infoText.accessibilityForDisabled') }}</span>
        </div>
        <div
          class="toggle-visual relative w-12 h-8 bg-gray-400 hover:bg-gray-300 peer-disabled:bg-gray-100 transition-all rounded-full peer peer-checked:after:translate-x-[16px] rtl:peer-checked:after:-translate-x-[16px] after:absolute after:top-[1px] after:start-[1px] after:bg-white after:rounded-full after:h-[30px] after:w-[30px] after:transition-all peer-disabled:after:bg-gray-300 peer-checked:after:text-primary-600 peer-checked:bg-primary-600">
        </div>
      </label>
    </div>

    <div class="flex flex-col gap-6">
      <h3 class="h3 text-black">{{ t('subheaders.features') }}</h3>
      <div class="font-semibold flex items-center gap-2 text-gray-950 group-disabled:text-gray-300">
        {{ t('helperText.selectAllValues') }}
        <i class="icon-info-circle text-gray-700 text-xl"></i>
      </div>
      <div  class="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-5 gap-4">
        <label *ngFor="let item of featuresTileOptions" class="visual-checkbox flex flex-col flex-1" [for]="item.name">
          <input
            type="checkbox"
            [id]="item.name"
            [checked]="isCheckedFeature(item.name)"
            (change)="toggleFeature(item.name, $event)"
            class="opacity-0 absolute h-0 w-0">
          <i [ngClass]="item.icon" class="text-[40px]"></i>
          <span>{{ t(item.name) }}</span>
        </label>
      </div>
    </div>

    <div class="flex flex-col gap-6">
      <h3 class="h3 text-black">{{ t('subheaders.parking') }}</h3>
      <div class="font-semibold flex items-center gap-2 text-gray-950 group-disabled:text-gray-300">
        <i class="icon-car-garage text-primary-900"></i>
        {{ t('labels.parkingType') }}
      </div>
      <div class="flex flex-col md:flex-row gap-4">

        <label class="visual-checkbox flex flex-col" for="parkingTypeOpen">
          <input (click)="onParkingTypeClick(parkingType.Open)"
            [checked]="(featuresFormGroup.controls.parkingType.value ?? []).indexOf(parkingType.Open) > -1"
            class="opacity-0 absolute h-0 w-0" id="parkingTypeOpen" type="checkbox">
          <span class="">{{ 'shared.enum.parkingType.' + parkingType.Open.toString() | transloco }}</span>
        </label>


        <label class="visual-checkbox flex flex-col" for="parkingTypeClosed">
          <input (click)="onParkingTypeClick(parkingType.Closed)"
            [checked]="(featuresFormGroup.controls.parkingType.value ?? []).indexOf(parkingType.Closed) > -1"
            class="opacity-0 absolute h-0 w-0" id="parkingTypeClosed" type="checkbox">
          <span class="">{{ 'shared.enum.parkingType.' + parkingType.Closed.toString() | transloco }}</span>
        </label>

        <label class="visual-checkbox flex flex-col" for="parkingTypeShared">
          <input (click)="onParkingTypeClick(parkingType.Shared);"
            [checked]="(featuresFormGroup.controls.parkingType.value ?? []).indexOf(parkingType.Shared) > -1"
            class="opacity-0 absolute h-0 w-0" id="parkingTypeShared" type="checkbox">
          <span class="">{{ 'shared.enum.parkingType.' + parkingType.Shared.toString() | transloco }}</span>
        </label>


        <label class="visual-checkbox flex flex-col" for="parkingTypeUnderground">
          <input (click)="onParkingTypeClick(parkingType.Underground)"
            [checked]="(featuresFormGroup.controls.parkingType.value ?? []).indexOf(parkingType.Underground) > -1"
            class="opacity-0 absolute h-0 w-0" id="parkingTypeUnderground" type="checkbox">
          <span class="">{{
            'shared.enum.parkingType.' + parkingType.Underground.toString() |
            transloco
            }}</span>
        </label>


        <label class="visual-checkbox flex flex-col" for="parkingTypeCarport">
          <input (click)="onParkingTypeClick(parkingType.Carport)"
            [checked]="(featuresFormGroup.controls.parkingType.value ?? []).indexOf(parkingType.Carport) > -1"
            class="opacity-0 absolute h-0 w-0" id="parkingTypeCarport" type="checkbox">
          <span class="">{{ 'shared.enum.parkingType.' + parkingType.Carport.toString() | transloco }}</span>
        </label>

      </div>
      <div class="font-semibold flex items-center gap-2 text-gray-950 group-disabled:text-gray-300">
        <i class="icon-car text-primary-900"></i>
        {{ t('labels.parkingSpace') }}
      </div>
      <div class="flex flex-col md:flex-row gap-4">

        <label class="visual-checkbox flex flex-col" for="parkingSpaceOne">
          <input (click)="featuresFormGroup.controls.parkingSpace.setValue(1)"
            [checked]="featuresFormGroup.controls.parkingSpace.value === 1"
            [disabled]="featuresFormGroup.controls.parkingType.value == parkingType.None"
            class="opacity-0 absolute h-0 w-0" id="parkingSpaceOne" type="checkbox">
          <span class="">1</span>
        </label>


        <label class="visual-checkbox flex flex-col" for="parkingSpaceTwo">
          <input (click)="featuresFormGroup.controls.parkingSpace.setValue(2)"
            [checked]="featuresFormGroup.controls.parkingSpace.value === 2"
            [disabled]="featuresFormGroup.controls.parkingType.value == parkingType.None"
            class="opacity-0 absolute h-0 w-0" id="parkingSpaceTwo" type="checkbox">
          <span class="">2</span>
        </label>


        <label class="visual-checkbox flex flex-col" for="parkingSpaceThree">
          <input (click)="featuresFormGroup.controls.parkingSpace.setValue(3)"
            [checked]="featuresFormGroup.controls.parkingSpace.value === 3"
            [disabled]="featuresFormGroup.controls.parkingType.value == parkingType.None"
            class="opacity-0 absolute h-0 w-0" id="parkingSpaceThree" type="checkbox">
          <span class="">3</span>
        </label>


        <label class="visual-checkbox flex flex-col" for="parkingSpaceFour">
          <input (click)="featuresFormGroup.controls.parkingSpace.setValue(4)"
            [checked]="featuresFormGroup.controls.parkingSpace.value === 4"
            [disabled]="featuresFormGroup.controls.parkingType.value == parkingType.None"
            class="opacity-0 absolute h-0 w-0" id="parkingSpaceFour" type="checkbox">
          <span class="">4</span>
        </label>


        <label class="visual-checkbox flex flex-col" for="parkingSpaceFivePlus">
          <input (click)="featuresFormGroup.controls.parkingSpace.setValue(5)"
            [checked]="featuresFormGroup.controls.parkingSpace.value >= 5"
            [disabled]="featuresFormGroup.controls.parkingType.value == parkingType.None"
            class="opacity-0 absolute h-0 w-0" id="parkingSpaceFivePlus" type="checkbox">
          <span class="">5+</span>
        </label>

      </div>
    </div>
  </div>